import { Pipe, PipeTransform } from '@angular/core';

import { UtilityTs } from '../util/utilityTs';

@Pipe({
    name: 'age'
})
export class AgePipe implements PipeTransform {

    transform(value: any) {
        // if (value != null) {
        //     if (value.seconds) {
        //         value = new Date(value.seconds * 1000);
        //     }
        //     if (Number.isInteger(value)) {
        //         value = new Date(value);
        //     }

        //     let today = new Date();
        //     return Math.round((today.getTime() - value.getTime()) / (86400000)) + " (days)";
        // } else {
        //     return "-";
        // }

        let age = UtilityTs.getAge(value);
        if (age == 0) {
            return "";
        } else {
            return age + ' Yr';
        }
    }

}
